import {
  SideBarActions,
  SideBarActionTypes
} from '../actions/side-bar.actions';
import { all } from 'deepmerge';
import { SideBarConfig } from './side-bar-config';

export interface SideBarState {
  config: SideBarConfig;
  /**
   * true - force shown
   * null - auto
   * false - force hidden
   */
  show: boolean | null;
}

export const defaultSideBarConfig: SideBarConfig = {
  logoSrc:
    'https://digitaix.de/img/logo_digitaix_full.png',
  logoWidth: '272px',
  logoHeight: '112px',
};

export const sideBarInitialState: SideBarState = {
  config: defaultSideBarConfig,
  show: null,
};

export function sideBarReducer(
  state = sideBarInitialState,
  action: SideBarActions,
): SideBarState {
  switch (action.type) {
    case SideBarActionTypes.SetSideBarConfig:
      return {
        ...state,
        config: all([state.config, action.config || {}]) as any,
      };

    case SideBarActionTypes.ShowSideBar:
      return { ...state, show: true };

    case SideBarActionTypes.HideSideBar:
      return { ...state, show: false };

    case SideBarActionTypes.ToggleSideBar:
      return { ...state, show: !state.show };

    case SideBarActionTypes.AutoShowSideBar:
      return { ...state, show: null };

    default:
      return state;
  }
}
